module.exports = __webpack_public_path__ + "static/media/cancel_response.95e239eb.jpg";